module.exports = __webpack_public_path__ + "img/pauli-z-root-dagger-23.83d2faea.svg";